import styled from "styled-components";

export const BlockContainer = styled.div`
    background: #fff;
    flex-direction: column;
    justify-content: space-between;
    display: flex;
    padding: 20px;
    gap: 15px;
`;

export const BlockTitle = styled.div`
    color: #333;
    font-family: "Source Sans Pro";
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 1px;
    text-transform: uppercase;
`;

export const BlockHeader = styled.div`
    color: #333;
    font-family: "Source Sans Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 125%;
    letter-spacing: -0.32px;
`;

export const BlockContentContainer = styled.div<{ left?: boolean, top?: boolean, dense?: boolean }>`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: ${props => props.left ? "flex-start" : "center"};
    justify-content: ${props => props.top ? "flex-start" : "center"};
    height: 100%;
    gap: ${props => props.dense ? "10px" : "20px"};
`;
